// modules/estrategias/vejez/offline/vejezOffline.js
// Capa fina sobre crudOfflineFactory.js — ahí vive la lógica real
// (evitar pendientes duplicados al reeditar, soportar eliminar offline).
import { crearCrudOffline } from "../../../inicio/offline/crudOfflineFactory";
import { crearPersonaAPI, actualizarPersonaAPI, deletePersona } from "../api/VejezAPI";

const crud = crearCrudOffline({
  tablaPendientes: "vejez_pendientes",
  apiCrear: crearPersonaAPI,
  apiActualizar: actualizarPersonaAPI,
  apiEliminar: deletePersona,
});

export const guardarOfflineVejez = (payload, personaId) => crud.guardarOffline(payload, personaId);
export const eliminarOfflineVejez = (personaId) => crud.eliminarOffline(personaId);
export const contarVejezPendientes = () => crud.contarPendientes();
export const sincronizarVejezPendientes = () => crud.sincronizarPendientes();
